'use strict';

var deleteUndefined = require('./deleteUndefined.js');
var removeNullValues = require('./removeNullValues.js');

/**
 * Removes undefined and null values from an object.
 *
 * @deprecated Relies on deleteUndefined and removeNullValues, which are deprecated.
 *
 * @param x - The object from which to remove undefined and null values.
 * @returns A new object with undefined and null values removed.
 */ function nonNullableObject(x) {
    return deleteUndefined(removeNullValues(x));
}

module.exports = nonNullableObject;
